/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type QuoteRequestMethod = typeof QuoteRequestMethod[keyof typeof QuoteRequestMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH_DROP_OFF: 'CASH_DROP_OFF',
  CASH_PICKUP: 'CASH_PICKUP',
  UNIONPAY: 'UNIONPAY',
  CREDIT_CARD: 'CREDIT_CARD',
  BANK_SWIFT: 'BANK_SWIFT',
  ALIPAY: 'ALIPAY',
} as const;
